/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import {
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';

import {
    QuestionFormWithOptionsBase,
    QuestionFormWithOptionsBaseProps,
    QuestionFormWithOptionsBaseStates
} from '../QuestionFormWithOptionsBase';
import {
    QTYPES,
    OPTION_TYPES,
    MULTIMEDIA_TYPES,
    Question
} from '@nexxt/common/types';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import UploadImage from '../../../common/uploadMedia/uploadimage';
import MediaLibraryAddModal from '../../../../../libraries/mediaLibrary/MediaLibraryAddModal';
import MultimediaBubble from '../../../common/MultimediaBubble';

type Props = QuestionFormWithOptionsBaseProps;

type States = QuestionFormWithOptionsBaseStates;

class RateImage extends QuestionFormWithOptionsBase<Props, States> {
    constructor(p: QuestionFormWithOptionsBaseProps) {
        super(p, QTYPES.RATE_IMAGE);
        const options = this.state.question.options || [];
        const question = {
            ...this.state.question,
            showContinueButton: true,
            selectedOptionType: OPTION_TYPES.HIGHLIGHT,
            options: options.length === 0 ? this.getDefaultOptions() : options,
            showImage: false,
            showText: false
        } as Question;
        this.state = {
            ...this.state,
            showCardSettings: true,
            question
        };
    }

    getDefaultOptions = () => {
        return [
            {
                label: 'Positive',
                value: 1,
                color: '#14a900',
                mediaURL: null,
                texts: [
                    {
                        language: 'en',
                        text: 'Positive'
                    }
                ]
            },
            {
                label: 'Negative',
                value: 2,
                color: '#a90000',
                mediaURL: null,
                texts: [
                    {
                        language: 'en',
                        text: 'Negative'
                    }
                ]
            },
            {
                label: 'Neutral',
                value: 3,
                color: '#b49000',
                mediaURL: null,
                texts: [
                    {
                        language: 'en',
                        text: 'Neutral'
                    }
                ]
            }
        ];
    };
    render() {
        const { currentProject } = this.props;
        const {
            question,
            isOptionSettingsOpen,
            isSettingBoxLayoutOpen,
            showCardSettings
        } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};
        return (
            <React.Fragment>
                {this.state.isMediaLibraryOpen && (
                    <MediaLibraryAddModal
                        isOpen={this.state.isMediaLibraryOpen}
                        setSelectedMedia={this.selectMedia}
                        notify={this.props.notify}
                        onCancel={this.closeMediaLibrary}
                        onClose={this.closeMediaLibrary}
                        type={this.state.mediaType}
                        showMediaLibrary={true}
                    />
                )}
                <div>
                    <div className="project-add--question-builder">
                        <BuilderHeader
                            toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                            isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                            showAlert={!this.props.editEnabled}
                            alertMessages={this.getWarningMessage()}
                            errorObject={this.state.questionError}
                        />
                        {/** Question builder body */}
                        <div className="builder-body">
                            {(isSettingBoxLayoutOpen && (
                                <QuestionSettings
                                    onClose={this.toggleSettingBoxLayout}
                                    question={question}
                                    questionSettings={{
                                        allowUserEdit: true
                                    }}
                                    setValue={this.setQuestion}
                                    disabled={!this.props.editEnabled}
                                />
                            )) ||
                                null}
                            {this.renderErrorNotes()}
                            <MultimediaBubble
                                question={question}
                                languages={currentProject.languages}
                                setValue={this.setQuestion}
                                setValueWithLanguage={
                                    this.NEW_setQuestionTextTranslation
                                }
                                addNewBubble={this.NEW_addNewEditor}
                                removeBubble={this.NEW_removeEditor}
                                disabled={!this.props.editEnabled}
                                questionError={questionError}
                                settings={{ showClose: true }}
                            />
                            <UploadImage
                                image={question.mediaURL || ''}
                                error={questionError.mediaURL || ''}
                                label="Upload Image"
                                subLabel="(Image upload: JPG, PNG, 8:10 recommended)"
                                onEdit={this.toggleMediaLibrary('image')}
                                disabled={!this.props.editEnabled}
                            />
                            <div className="option-settings-blcok">
                                <div className="form-group-header display-flex">
                                    Highlighter options
                                </div>
                            </div>
                            {showCardSettings && this.renderOptionCard()}{' '}
                            {this.renderOptionAddButton(
                                (this.state.question.options || []).length > 4
                            )}{' '}
                            <MultimediaBubble
                                languages={currentProject.languages}
                                question={question}
                                setValue={this.setQuestion}
                                setValueWithLanguage={
                                    this.NEW_setQuestionTextTranslation
                                }
                                questionError={questionError}
                                keyName="continueTexts"
                                disabled={!this.props.editEnabled}
                                disableAddBubble
                                defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                questionText="Continue button text"
                                defaultText="BUTTON.CONTINUE"
                                settings={{
                                    noBorder: true,
                                    useTranslation: true
                                }}
                            />
                        </div>

                        {/** End of question builder body */}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(RateImage)
    )
);
